/* Timezones from Google Calendar */

export default [
  {
    text: 'Niue',
    value: 'Pacific/Niue',
    offset: -11,
  },
  {
    text: 'Pago Pago',
    value: 'Pacific/Pago_Pago',
    offset: -11,
  },
  {
    text: 'Hawaii Time',
    value: 'Pacific/Honolulu',
    offset: -10,
  },
  {
    text: 'Rarotonga',
    value: 'Pacific/Rarotonga',
    offset: -10,
  },
  {
    text: 'Tahiti',
    value: 'Pacific/Tahiti',
    offset: -10,
  },
  {
    text: 'Gambier',
    value: 'Pacific/Gambier',
    offset: -9,
  },
  {
    text: 'Alaska Time',
    value: 'America/Anchorage',
    offset: -8,
  },
  {
    text: 'Pitcairn',
    value: 'Pacific/Pitcairn',
    offset: -8,
  },
  {
    text: 'Dawson',
    value: 'America/Dawson',
    offset: -7,
  },
  {
    text: 'Phoenix',
    value: 'America/Phoenix',
    offset: -7,
  },
  {
    text: 'Pacific Time',
    value: 'America/Los_Angeles',
    offset: -7,
  },
  {
    text: 'Pacific Time - Tijuana',
    value: 'America/Tijuana',
    offset: -7,
  },
  {
    text: 'Pacific Time - Vancouver',
    value: 'America/Vancouver',
    offset: -7,
  },
  {
    text: 'Pacific Time - Whitehorse',
    value: 'America/Whitehorse',
    offset: -7,
  },
  {
    text: 'Belize',
    value: 'America/Belize',
    offset: -6,
  },
  {
    text: 'Boise',
    value: 'America/Boise',
    offset: -6,
  },
  {
    text: 'Central Time - Regina',
    value: 'America/Regina',
    offset: -6,
  },
  {
    text: 'Central Time - Tegucigalpa',
    value: 'America/Tegucigalpa',
    offset: -6,
  },
  {
    text: 'Costa Rica',
    value: 'America/Costa_Rica',
    offset: -6,
  },
  {
    text: 'Easter Island',
    value: 'Pacific/Easter',
    offset: -6,
  },
  {
    text: 'El Salvador',
    value: 'America/El_Salvador',
    offset: -6,
  },
  {
    text: 'Galapagos',
    value: 'Pacific/Galapagos',
    offset: -6,
  },
  {
    text: 'Guatemala',
    value: 'America/Guatemala',
    offset: -6,
  },
  {
    text: 'Managua',
    value: 'America/Managua',
    offset: -6,
  },
  {
    text: 'Mountain Time',
    value: 'America/Denver',
    offset: -6,
  },
  {
    text: 'Chihuahua, Mazatlan',
    value: 'America/Mazatlan',
    offset: -6,
  },
  {
    text: 'Mountain Time - Edmonton',
    value: 'America/Edmonton',
    offset: -6,
  },
  {
    text: 'Mountain Time - Yellowknife',
    value: 'America/Yellowknife',
    offset: -6,
  },
  {
    text: 'America Cancun',
    value: 'America/Cancun',
    offset: -5,
  },
  {
    text: 'Bogota',
    value: 'America/Bogota',
    offset: -5,
  },
  {
    text: 'Central Time',
    value: 'America/Chicago',
    offset: -5,
  },
  {
    text: 'Central Time - Mexico City',
    value: 'America/Mexico_City',
    offset: -5,
  },
  {
    text: 'Central Time - Winnipeg',
    value: 'America/Winnipeg',
    offset: -5,
  },
  {
    text: 'Guayaquil',
    value: 'America/Guayaquil',
    offset: -5,
  },
  {
    text: 'Jamaica',
    value: 'America/Jamaica',
    offset: -5,
  },
  {
    text: 'Lima',
    value: 'America/Lima',
    offset: -5,
  },
  {
    text: 'Panama',
    value: 'America/Panama',
    offset: -5,
  },
  {
    text: 'Rio Branco',
    value: 'America/Rio_Branco',
    offset: -5,
  },
  {
    text: 'Asuncion',
    value: 'America/Asuncion',
    offset: -4,
  },
  {
    text: 'Barbados',
    value: 'America/Barbados',
    offset: -4,
  },
  {
    text: 'Boa Vista',
    value: 'America/Boa_Vista',
    offset: -4,
  },
  {
    text: 'Campo Grande',
    value: 'America/Campo_Grande',
    offset: -4,
  },
  {
    text: 'Caracas',
    value: 'America/Caracas',
    offset: -4,
  },
  {
    text: 'Cuiaba',
    value: 'America/Cuiaba',
    offset: -4,
  },
  {
    text: 'Curacao',
    value: 'America/Curacao',
    offset: -4,
  },
  {
    text: 'Detroit',
    value: 'America/Detroit',
    offset: -4,
  },
  {
    text: 'New York',
    value: 'America/New_York',
    offset: -4,
  },
  {
    text: 'Iqaluit',
    value: 'America/Iqaluit',
    offset: -4,
  },
  {
    text: 'Toronto',
    value: 'America/Toronto',
    offset: -4,
  },
  {
    text: 'Grand Turk',
    value: 'America/Grand_Turk',
    offset: -4,
  },
  {
    text: 'Guyana',
    value: 'America/Guyana',
    offset: -4,
  },
  {
    text: 'Havana',
    value: 'America/Havana',
    offset: -4,
  },
  {
    text: 'La Paz',
    value: 'America/La_Paz',
    offset: -4,
  },
  {
    text: 'Manaus',
    value: 'America/Manaus',
    offset: -4,
  },
  {
    text: 'Martinique',
    value: 'America/Martinique',
    offset: -4,
  },
  {
    text: 'Nassau',
    value: 'America/Nassau',
    offset: -4,
  },
  {
    text: 'Port of Spain',
    value: 'America/Port_of_Spain',
    offset: -4,
  },
  {
    text: 'Port-au-Prince',
    value: 'America/Port-au-Prince',
    offset: -4,
  },
  {
    text: 'Porto Velho',
    value: 'America/Porto_Velho',
    offset: -4,
  },
  {
    text: 'Puerto Rico',
    value: 'America/Puerto_Rico',
    offset: -4,
  },
  {
    text: 'Santiago',
    value: 'America/Santiago',
    offset: -4,
  },
  {
    text: 'Santo Domingo',
    value: 'America/Santo_Domingo',
    offset: -4,
  },
  {
    text: 'Araguaina',
    value: 'America/Araguaina',
    offset: -3,
  },
  {
    text: 'Atlantic Time - Halifax',
    value: 'America/Halifax',
    offset: -3,
  },
  {
    text: 'Belem',
    value: 'America/Belem',
    offset: -3,
  },
  {
    text: 'Bermuda',
    value: 'Atlantic/Bermuda',
    offset: -3,
  },
  {
    text: 'Buenos Aires',
    value: 'America/Argentina/Buenos_Aires',
    offset: -3,
  },
  {
    text: 'Cayenne',
    value: 'America/Cayenne',
    offset: -3,
  },
  {
    text: 'Cordoba',
    value: 'America/Argentina/Cordoba',
    offset: -3,
  },
  {
    text: 'Fortaleza',
    value: 'America/Fortaleza',
    offset: -3,
  },
  {
    text: 'Maceio',
    value: 'America/Maceio',
    offset: -3,
  },
  {
    text: 'Montevideo',
    value: 'America/Montevideo',
    offset: -3,
  },
  {
    text: 'Palmer',
    value: 'Antarctica/Palmer',
    offset: -3,
  },
  {
    text: 'Paramaribo',
    value: 'America/Paramaribo',
    offset: -3,
  },
  {
    text: 'Punta Arenas',
    value: 'America/Punta_Arenas',
    offset: -3,
  },
  {
    text: 'Recife',
    value: 'America/Recife',
    offset: -3,
  },
  {
    text: 'Rothera',
    value: 'Antarctica/Rothera',
    offset: -3,
  },
  {
    text: 'Salvador',
    value: 'America/Bahia',
    offset: -3,
  },
  {
    text: 'Sao Paulo',
    value: 'America/Sao_Paulo',
    offset: -3,
  },
  {
    text: 'Stanley',
    value: 'Atlantic/Stanley',
    offset: -3,
  },
  {
    text: 'Thule',
    value: 'America/Thule',
    offset: -3,
  },
  {
    text: 'Newfoundland Time - St. Johns',
    value: 'America/St_Johns',
    offset: -2.5,
  },
  {
    text: 'Godthab',
    value: 'America/Godthab',
    offset: -2,
  },
  {
    text: 'Miquelon',
    value: 'America/Miquelon',
    offset: -2,
  },
  {
    text: 'Noronha',
    value: 'America/Noronha',
    offset: -2,
  },
  {
    text: 'South Georgia',
    value: 'Atlantic/South_Georgia',
    offset: -2,
  },
  {
    text: 'Cape Verde',
    value: 'Atlantic/Cape_Verde',
    offset: -1,
  },
  {
    text: 'Abidjan',
    value: 'Africa/Abidjan',
    offset: 0,
  },
  {
    text: 'Accra',
    value: 'Africa/Accra',
    offset: 0,
  },
  {
    text: 'Azores',
    value: 'Atlantic/Azores',
    offset: 0,
  },
  {
    text: 'Bissau',
    value: 'Africa/Bissau',
    offset: 0,
  },
  {
    text: 'Casablanca',
    value: 'Africa/Casablanca',
    offset: 0,
  },
  {
    text: 'Danmarkshavn',
    value: 'America/Danmarkshavn',
    offset: 0,
  },
  {
    text: 'El Aaiun',
    value: 'Africa/El_Aaiun',
    offset: 0,
  },
  {
    text: 'GMT (no daylight saving)',
    value: 'Etc/GMT',
    offset: 0,
  },
  {
    text: 'Monrovia',
    value: 'Africa/Monrovia',
    offset: 0,
  },
  {
    text: 'Reykjavik',
    value: 'Atlantic/Reykjavik',
    offset: 0,
  },
  {
    text: 'Scoresbysund',
    value: 'America/Scoresbysund',
    offset: 0,
  },
  {
    text: 'UTC',
    value: 'UTC',
    offset: 0,
  },
  {
    text: 'Algiers',
    value: 'Africa/Algiers',
    offset: 1,
  },
  {
    text: 'Canary Islands',
    value: 'Atlantic/Canary',
    offset: 1,
  },
  {
    text: 'Dublin',
    value: 'Europe/Dublin',
    offset: 1,
  },
  {
    text: 'Faeroe',
    value: 'Atlantic/Faroe',
    offset: 1,
  },
  {
    text: 'Lagos',
    value: 'Africa/Lagos',
    offset: 1,
  },
  {
    text: 'Lisbon',
    value: 'Europe/Lisbon',
    offset: 1,
  },
  {
    text: 'London',
    value: 'Europe/London',
    offset: 1,
  },
  {
    text: 'Ndjamena',
    value: 'Africa/Ndjamena',
    offset: 1,
  },
  {
    text: 'Sao Tome',
    value: 'Africa/Sao_Tome',
    offset: 1,
  },
  {
    text: 'Tunis',
    value: 'Africa/Tunis',
    offset: 1,
  },
  {
    text: 'Amsterdam',
    value: 'Europe/Amsterdam',
    offset: 2,
  },
  {
    text: 'Andorra',
    value: 'Europe/Andorra',
    offset: 2,
  },
  {
    text: 'Berlin',
    value: 'Europe/Berlin',
    offset: 2,
  },
  {
    text: 'Brussels',
    value: 'Europe/Brussels',
    offset: 2,
  },
  {
    text: 'Budapest',
    value: 'Europe/Budapest',
    offset: 2,
  },
  {
    text: 'Cairo',
    value: 'Africa/Cairo',
    offset: 2,
  },
  {
    text: 'Central European Time - Belgrade',
    value: 'Europe/Belgrade',
    offset: 2,
  },
  {
    text: 'Central European Time - Prague',
    value: 'Europe/Prague',
    offset: 2,
  },
  {
    text: 'Ceuta',
    value: 'Africa/Ceuta',
    offset: 2,
  },
  {
    text: 'Copenhagen',
    value: 'Europe/Copenhagen',
    offset: 2,
  },
  {
    text: 'Gibraltar',
    value: 'Europe/Gibraltar',
    offset: 2,
  },
  {
    text: 'Johannesburg',
    value: 'Africa/Johannesburg',
    offset: 2,
  },
  {
    text: 'Khartoum',
    value: 'Africa/Khartoum',
    offset: 2,
  },
  {
    text: 'Luxembourg',
    value: 'Europe/Luxembourg',
    offset: 2,
  },
  {
    text: 'Madrid',
    value: 'Europe/Madrid',
    offset: 2,
  },
  {
    text: 'Malta',
    value: 'Europe/Malta',
    offset: 2,
  },
  {
    text: 'Maputo',
    value: 'Africa/Maputo',
    offset: 2,
  },
  {
    text: 'Monaco',
    value: 'Europe/Monaco',
    offset: 2,
  },
  {
    text: 'Kaliningrad',
    value: 'Europe/Kaliningrad',
    offset: 2,
  },
  {
    text: 'Oslo',
    value: 'Europe/Oslo',
    offset: 2,
  },
  {
    text: 'Paris',
    value: 'Europe/Paris',
    offset: 2,
  },
  {
    text: 'Rome',
    value: 'Europe/Rome',
    offset: 2,
  },
  {
    text: 'Stockholm',
    value: 'Europe/Stockholm',
    offset: 2,
  },
  {
    text: 'Tirane',
    value: 'Europe/Tirane',
    offset: 2,
  },
  {
    text: 'Tripoli',
    value: 'Africa/Tripoli',
    offset: 2,
  },
  {
    text: 'Vienna',
    value: 'Europe/Vienna',
    offset: 2,
  },
  {
    text: 'Warsaw',
    value: 'Europe/Warsaw',
    offset: 2,
  },
  {
    text: 'Windhoek',
    value: 'Africa/Windhoek',
    offset: 2,
  },
  {
    text: 'Zurich',
    value: 'Europe/Zurich',
    offset: 2,
  },
  {
    text: 'Amman',
    value: 'Asia/Amman',
    offset: 3,
  },
  {
    text: 'Athens',
    value: 'Europe/Athens',
    offset: 3,
  },
  {
    text: 'Baghdad',
    value: 'Asia/Baghdad',
    offset: 3,
  },
  {
    text: 'Beirut',
    value: 'Asia/Beirut',
    offset: 3,
  },
  {
    text: 'Bucharest',
    value: 'Europe/Bucharest',
    offset: 3,
  },
  {
    text: 'Chisinau',
    value: 'Europe/Chisinau',
    offset: 3,
  },
  {
    text: 'Damascus',
    value: 'Asia/Damascus',
    offset: 3,
  },
  {
    text: 'Gaza',
    value: 'Asia/Gaza',
    offset: 3,
  },
  {
    text: 'Helsinki',
    value: 'Europe/Helsinki',
    offset: 3,
  },
  {
    text: 'Istanbul',
    value: 'Europe/Istanbul',
    offset: 3,
  },
  {
    text: 'Jerusalem',
    value: 'Asia/Jerusalem',
    offset: 3,
  },
  {
    text: 'Kiev',
    value: 'Europe/Kiev',
    offset: 3,
  },
  {
    text: 'Minsk',
    value: 'Europe/Minsk',
    offset: 3,
  },
  {
    text: 'Moscow',
    value: 'Europe/Moscow',
    offset: 3,
  },
  {
    text: 'Nairobi',
    value: 'Africa/Nairobi',
    offset: 3,
  },
  {
    text: 'Nicosia',
    value: 'Asia/Nicosia',
    offset: 3,
  },
  {
    text: 'Qatar',
    value: 'Asia/Qatar',
    offset: 3,
  },
  {
    text: 'Riga',
    value: 'Europe/Riga',
    offset: 3,
  },
  {
    text: 'Riyadh',
    value: 'Asia/Riyadh',
    offset: 3,
  },
  {
    text: 'Sofia',
    value: 'Europe/Sofia',
    offset: 3,
  },
  {
    text: 'Syowa',
    value: 'Antarctica/Syowa',
    offset: 3,
  },
  {
    text: 'Tallinn',
    value: 'Europe/Tallinn',
    offset: 3,
  },
  {
    text: 'Vilnius',
    value: 'Europe/Vilnius',
    offset: 3,
  },
  {
    text: 'Baku',
    value: 'Asia/Baku',
    offset: 4,
  },
  {
    text: 'Dubai',
    value: 'Asia/Dubai',
    offset: 4,
  },
  {
    text: 'Mahe',
    value: 'Indian/Mahe',
    offset: 4,
  },
  {
    text: 'Mauritius',
    value: 'Indian/Mauritius',
    offset: 4,
  },
  {
    text: 'Samara',
    value: 'Europe/Samara',
    offset: 4,
  },
  {
    text: 'Reunion',
    value: 'Indian/Reunion',
    offset: 4,
  },
  {
    text: 'Tbilisi',
    value: 'Asia/Tbilisi',
    offset: 4,
  },
  {
    text: 'Yerevan',
    value: 'Asia/Yerevan',
    offset: 4,
  },
  {
    text: 'Kabul',
    value: 'Asia/Kabul',
    offset: 4.5,
  },
  {
    text: 'Tehran',
    value: 'Asia/Tehran',
    offset: 4.5,
  },
  {
    text: 'Aqtau',
    value: 'Asia/Aqtau',
    offset: 5,
  },
  {
    text: 'Aqtobe',
    value: 'Asia/Aqtobe',
    offset: 5,
  },
  {
    text: 'Ashgabat',
    value: 'Asia/Ashgabat',
    offset: 5,
  },
  {
    text: 'Dushanbe',
    value: 'Asia/Dushanbe',
    offset: 5,
  },
  {
    text: 'Karachi',
    value: 'Asia/Karachi',
    offset: 5,
  },
  {
    text: 'Kerguelen',
    value: 'Indian/Kerguelen',
    offset: 5,
  },
  {
    text: 'Maldives',
    value: 'Indian/Maldives',
    offset: 5,
  },
  {
    text: 'Mawson',
    value: 'Antarctica/Mawson',
    offset: 5,
  },
  {
    text: 'Yekaterinburg',
    value: 'Asia/Yekaterinburg',
    offset: 5,
  },
  {
    text: 'Tashkent',
    value: 'Asia/Tashkent',
    offset: 5,
  },
  {
    text: 'Colombo',
    value: 'Asia/Colombo',
    offset: 5.5,
  },
  {
    text: 'India Standard Time',
    value: 'Asia/Calcutta',
    offset: 5.5,
  },
  {
    text: 'Katmandu',
    value: 'Asia/Katmandu',
    offset: 5.75,
  },
  {
    text: 'Almaty',
    value: 'Asia/Almaty',
    offset: 6,
  },
  {
    text: 'Bishkek',
    value: 'Asia/Bishkek',
    offset: 6,
  },
  {
    text: 'Chagos',
    value: 'Indian/Chagos',
    offset: 6,
  },
  {
    text: 'Dhaka',
    value: 'Asia/Dhaka',
    offset: 6,
  },
  {
    text: 'Omsk',
    value: 'Asia/Omsk',
    offset: 6,
  },
  {
    text: 'Thimphu',
    value: 'Asia/Thimphu',
    offset: 6,
  },
  {
    text: 'Vostok',
    value: 'Antarctica/Vostok',
    offset: 6,
  },
  {
    text: 'Cocos',
    value: 'Indian/Cocos',
    offset: 6.5,
  },
  {
    text: 'Rangoon',
    value: 'Asia/Yangon',
    offset: 6.5,
  },
  {
    text: 'Bangkok',
    value: 'Asia/Bangkok',
    offset: 7,
  },
  {
    text: 'Christmas',
    value: 'Indian/Christmas',
    offset: 7,
  },
  {
    text: 'Davis',
    value: 'Antarctica/Davis',
    offset: 7,
  },
  {
    text: 'Hanoi',
    value: 'Asia/Saigon',
    offset: 7,
  },
  {
    text: 'Hovd',
    value: 'Asia/Hovd',
    offset: 7,
  },
  {
    text: 'Jakarta',
    value: 'Asia/Jakarta',
    offset: 7,
  },
  {
    text: 'Krasnoyarsk',
    value: 'Asia/Krasnoyarsk',
    offset: 7,
  },
  {
    text: 'Brunei',
    value: 'Asia/Brunei',
    offset: 8,
  },
  {
    text: 'Casey',
    value: 'Antarctica/Casey',
    offset: 8,
  },
  {
    text: 'China Time - Beijing',
    value: 'Asia/Shanghai',
    offset: 8,
  },
  {
    text: 'Choibalsan',
    value: 'Asia/Choibalsan',
    offset: 8,
  },
  {
    text: 'Hong Kong',
    value: 'Asia/Hong_Kong',
    offset: 8,
  },
  {
    text: 'Kuala Lumpur',
    value: 'Asia/Kuala_Lumpur',
    offset: 8,
  },
  {
    text: 'Macau',
    value: 'Asia/Macau',
    offset: 8,
  },
  {
    text: 'Makassar',
    value: 'Asia/Makassar',
    offset: 8,
  },
  {
    text: 'Manila',
    value: 'Asia/Manila',
    offset: 8,
  },
  {
    text: 'Irkutsk',
    value: 'Asia/Irkutsk',
    offset: 8,
  },
  {
    text: 'Singapore',
    value: 'Asia/Singapore',
    offset: 8,
  },
  {
    text: 'Taipei',
    value: 'Asia/Taipei',
    offset: 8,
  },
  {
    text: 'Ulaanbaatar',
    value: 'Asia/Ulaanbaatar',
    offset: 8,
  },
  {
    text: 'Western Time - Perth',
    value: 'Australia/Perth',
    offset: 8,
  },
  {
    text: 'Dili',
    value: 'Asia/Dili',
    offset: 9,
  },
  {
    text: 'Jayapura',
    value: 'Asia/Jayapura',
    offset: 9,
  },
  {
    text: 'Yakutsk',
    value: 'Asia/Yakutsk',
    offset: 9,
  },
  {
    text: 'Palau',
    value: 'Pacific/Palau',
    offset: 9,
  },
  {
    text: 'Pyongyang',
    value: 'Asia/Pyongyang',
    offset: 9,
  },
  {
    text: 'Seoul',
    value: 'Asia/Seoul',
    offset: 9,
  },
  {
    text: 'Tokyo',
    value: 'Asia/Tokyo',
    offset: 9,
  },
  {
    text: "Dumont D'Urville",
    value: 'Antarctica/DumontDUrville',
    offset: 10,
  },
  {
    text: 'Brisbane',
    value: 'Australia/Brisbane',
    offset: 10,
  },
  {
    text: 'Hobart',
    value: 'Australia/Hobart',
    offset: 10,
  },
  {
    text: 'Melbourne',
    value: 'Australia/Melbourne',
    offset: 10,
  },
  {
    text: 'Sydney',
    value: 'Australia/Sydney',
    offset: 10,
  },
  {
    text: 'Guam',
    value: 'Pacific/Guam',
    offset: 10,
  },
  {
    text: 'Vladivostok',
    value: 'Asia/Vladivostok',
    offset: 10,
  },
  {
    text: 'Port Moresby',
    value: 'Pacific/Port_Moresby',
    offset: 10,
  },
  {
    text: 'Truk',
    value: 'Pacific/Chuuk',
    offset: 10,
  },
  {
    text: 'Efate',
    value: 'Pacific/Efate',
    offset: 11,
  },
  {
    text: 'Guadalcanal',
    value: 'Pacific/Guadalcanal',
    offset: 11,
  },
  {
    text: 'Kosrae',
    value: 'Pacific/Kosrae',
    offset: 11,
  },
  {
    text: 'Magadan',
    value: 'Asia/Magadan',
    offset: 11,
  },
  {
    text: 'Norfolk',
    value: 'Pacific/Norfolk',
    offset: 11,
  },
  {
    text: 'Noumea',
    value: 'Pacific/Noumea',
    offset: 11,
  },
  {
    text: 'Ponape',
    value: 'Pacific/Pohnpei',
    offset: 11,
  },
  {
    text: 'Auckland',
    value: 'Pacific/Auckland',
    offset: 12,
  },
  {
    text: 'Fiji',
    value: 'Pacific/Fiji',
    offset: 12,
  },
  {
    text: 'Funafuti',
    value: 'Pacific/Funafuti',
    offset: 12,
  },
  {
    text: 'Kwajalein',
    value: 'Pacific/Kwajalein',
    offset: 12,
  },
  {
    text: 'Majuro',
    value: 'Pacific/Majuro',
    offset: 12,
  },
  {
    text: 'Petropavlovsk-Kamchatskiy',
    value: 'Asia/Kamchatka',
    offset: 12,
  },
  {
    text: 'Nauru',
    value: 'Pacific/Nauru',
    offset: 12,
  },
  {
    text: 'Tarawa',
    value: 'Pacific/Tarawa',
    offset: 12,
  },
  {
    text: 'Wake',
    value: 'Pacific/Wake',
    offset: 12,
  },
  {
    text: 'Wallis',
    value: 'Pacific/Wallis',
    offset: 12,
  },
  {
    text: 'Apia',
    value: 'Pacific/Apia',
    offset: 13,
  },
  {
    text: 'Enderbury',
    value: 'Pacific/Enderbury',
    offset: 13,
  },
  {
    text: 'Fakaofo',
    value: 'Pacific/Fakaofo',
    offset: 13,
  },
  {
    text: 'Tongatapu',
    value: 'Pacific/Tongatapu',
    offset: 13,
  },
  {
    text: 'Kiritimati',
    value: 'Pacific/Kiritimati',
    offset: 14,
  },
];
